import controller from './help-icon.controller';

const template = require('./help-icon.html');

export default {
    bindings: {
        messageKey: '@'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/help-icon/help-icon.component.js